import { gql } from "generated-graphql";

export const TASKS_QUERY = gql(`
    query Tasks($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
      virtualEvents(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
        count
        items {
          id
          seriesId
          taskId
          frequency
          isRecurring
          interval
          title
          facilities {
            id
            name
          }
          status
          taskStatus
          deadline
          assignee {
            ...AssigneePicker
          }
          tags {
            id
            name
          }
        }
      }
    }
  `);

export const TASK_SERIES_QUERY = gql(`
    query TaskSeries($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
      taskSeries(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
        count
        items {
          id
          seriesId
          taskId
          frequency
          isRecurring
          interval
          title
          facilities {
            id
            name
          }
          status
          taskStatus
          deadline
          assignee {
            ...AssigneePicker
          }
          tags {
            id
            name
          }
        }
      }
    }
  `);

export const TASKS_COUNT_QUERY = gql(`
  query TasksCount($search: String) {
    virtualEvents(search: $search, page: 0, pageSize: 0) {
      count
    }
  }
`);
export const TASK_CALENDAR_SUBSCRIPTION_QUERY = gql(`
  query TaskCalendarSubscription($tenantId: ID!) {
    taskCalendarSubscription(tenantId: $tenantId) {
      url
      scope
      search
    }
  }
`);

export const SAVE_TASK_CALENDAR_SUBSCRIPTION_MUTATION = gql(`
  mutation SaveTaskCalendarSubscription(
    $tenantId: ID!
    $scope: TaskCalendarScope
    $search: String
  ) {
    saveTaskCalendarSubscription(tenantId: $tenantId, scope: $scope, search: $search) {
      url
      scope
      search
    }
  }
`);

gql(`
  fragment TaskCalendarPreviewItem on VirtualEvent {
    id
    title
    deadline
    taskStatus
    status
    isRecurring
    facilities {
      id
      name
    }
  }
`);

/**
 * Counts for a calendar feed search, plus its first few items by deadline: one
 * per task by series, or one per occurrence by date.
 */
export const TASK_CALENDAR_PREVIEW_QUERY = gql(`
  query TaskCalendarPreview($search: String!, $bySeries: Boolean!) {
    events: virtualEvents(
      search: $search
      page: 0
      pageSize: 5
      sort: [{ field: "deadline", sort: "asc" }]
    ) {
      count
      items @skip(if: $bySeries) {
        ...TaskCalendarPreviewItem
      }
    }
    tasks: taskSeries(
      search: $search
      page: 0
      pageSize: 5
      sort: [{ field: "deadline", sort: "asc" }]
    ) {
      count
      items @include(if: $bySeries) {
        ...TaskCalendarPreviewItem
      }
    }
  }
`);

export const REVOKE_TASK_CALENDAR_TOKEN_MUTATION = gql(`
  mutation RevokeTaskCalendarToken($tenantId: ID!) {
    revokeTaskCalendarToken(tenantId: $tenantId)
  }
`);

/**
 * Every query that lists tasks (list, series, and their counts). Mutations that
 * change tasks refetch all of them, so each view stays current.
 */
export const TASK_LIST_REFETCH_QUERIES = [TASKS_QUERY, TASK_SERIES_QUERY, TASKS_COUNT_QUERY];
